import BigNumber from "bignumber.js";

import { SubscriptionOptionsType } from "types";

// Calculate the total price of the selected services
export const getTotalPrice = (sectionValues: SubscriptionOptionsType) => {
	if (!sectionValues) {
		return 0;
	}

	const services = [
		sectionValues?.posSystem,
		sectionValues?.marketingServices,
		sectionValues?.ipPhoneService,
		sectionValues?.tapToPay,
		sectionValues?.salonInTheBox,
		sectionValues?.smsService,
		sectionValues?.smsMessage,
		sectionValues?.smsSetup,
	];

	const totalPrice = services.reduce((acc, service) => {
		if (service?.isSubscribed) {
			const costWithoutCommas = (service?.cost || 0)
				.toString()
				.replace(/,/g, "");
			const serviceCost = new BigNumber(costWithoutCommas);
			return acc.plus(serviceCost);
		}
		return acc;
	}, new BigNumber(0));

	const discountAmount = new BigNumber(
		(sectionValues?.discount || 0).toString().replace(/,/g, ""),
	);
	const finalPrice = totalPrice.minus(discountAmount);

	return finalPrice.toNumber();
};
